import { Game } from "../Game";
import { TIMER } from "./Gameplay";
import { GameWorld } from "./Game World/GameWorld";
import { Player } from "./Player/Player";
import { LevelManager } from "./Levels";

export class Camera {
    /**
     * Offset pozice kamery od pozice hrace
     */
    private static readonly X_OFFSET = 1;
    private static readonly Y_OFFSET = 2.604;
    private static readonly Z_OFFSET = 2.5;

    get entity(): pc.Entity { return this._entity; }
    private _entity: pc.Entity;

    /**
     * Aktualni pozice kamery na ose Z
     */
    private _curPos: number;

    /**
     * Rychlost pohybu kamery
     */
    private _speed: number;

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    constructor() {
        // Create entity
        this._entity = new pc.Entity("camera");
        this._entity.setEulerAngles(-48, 12, 0);

        // Create camera component
        this._entity.addComponent(pc.eCompomentType.camera, {
            fov: 55,
            nearClip: 0.1,
            farClip: 500,
            clearColor: new pc.Color(0.5921, 0.7569, 0.9687),
            frustumCulling: true
        });

        Game.APP.root.addChild(this._entity);
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    reset(): void {
        // Rychlost pohybu kamery za vterinu
        this._speed = LevelManager.INSTANCE.lvlSettings.player.walkSpeed * 1.05;

        // Pozice kamery
        let pos = Player.instance.cameraOrigin + Camera.Z_OFFSET;

        if (pos > GameWorld.instance.size + 0.5)
            pos = GameWorld.instance.size + 0.5;

        this._curPos = pos;
        this._entity.setPosition(GameWorld.PATH_X + Camera.X_OFFSET, Camera.Y_OFFSET, pos);
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    update(): void {
        let targetPos = Player.instance.cameraOrigin + Camera.Z_OFFSET;

        if (targetPos > GameWorld.instance.size + 0.5)
            targetPos = GameWorld.instance.size + 0.5;

        let step = this._speed * TIMER.deltaS;

        if (targetPos > this._curPos) {
            if ((this._curPos += step) > targetPos)
                this._curPos = targetPos;
        }
        else if ((this._curPos -= step) < targetPos) {
            this._curPos = targetPos;
        }

        this._entity.setPosition(GameWorld.PATH_X + Camera.X_OFFSET, Camera.Y_OFFSET, this._curPos);
    }
}